import React from 'react';
import { Icon } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import Carousel from '../../../../../../darkmatter/Carousel';
import { ImagesPropType } from '../../../../../../services/proptypes';
import './LightboxImageDisplay.css';
function LightboxImageDisplay(_ref) {
  var images = _ref.images;
  if (_isEmpty(images)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "lightbox-image-display"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, images.length === 1 && /*#__PURE__*/React.createElement(Image, {
    className: "lightbox-image",
    src: images[0]
  }), images.length > 1 && /*#__PURE__*/React.createElement(Carousel, {
    totalNumberOfItems: images.length
  }, function (_ref2) {
    var currentIndex = _ref2.currentIndex,
      changeCurrentIndex = _ref2.changeCurrentIndex;
    return /*#__PURE__*/React.createElement("div", {
      className: "lightbox-image-carousel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-indicator"
    }, "".concat(currentIndex + 1, " / ").concat(images.length)), /*#__PURE__*/React.createElement("div", {
      className: "carousel"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "carousel-control",
      name: "angle left",
      onClick: function onClick() {
        return changeCurrentIndex(currentIndex - 1);
      }
    }), /*#__PURE__*/React.createElement(Image, {
      className: "lightbox-image",
      src: images[currentIndex]
    }), /*#__PURE__*/React.createElement(Icon, {
      className: "carousel-control",
      name: "angle right",
      onClick: function onClick() {
        return changeCurrentIndex(currentIndex + 1);
      }
    })));
  })));
}
export default LightboxImageDisplay;